

<h1 class="page-header">About Us</h1>

<section class="gradient-section-theme-color1">
    <div class="container">
        <div [innerHTML]="ABOUT_PAGE_ABOUT_US_FULL"></div>
    </div>
</section>
<!--
<section class="gradient-section-theme-color2">
    <div class="container">

        <h1>Our Vision</h1>

        <p>
            {{ABOUT_PAGE_OUR_VISION}}
        </p>
    </div>
</section>

<section class="gradient-section-theme-color3">
    <div class="container">
        <h1>Our Mission</h1>

        <p>
            {{ABOUT_PAGE_OUR_MISSION}}
        </p>

    </div>
</section>

<section class="gradient-section-theme-color1">
    <div class="container">
        <h1>Core Values</h1>
        <div [innerHTML]="ABOUT_PAGE_CORE_VALUES"></div>
    </div>
</section>

<section class="gradient-section-theme-color2">
    <div class="container">
        <h1>Products and Solutions</h1>
        <div [innerHTML]="ABOUT_PAGE_PRODUCTS_AND_SOLUTION"></div>
    </div>
</section>

<section class="gradient-section-theme-color3">
    <div class="container">
        <h1>Our Commitment to Innovation</h1>

        <p>
            {{ABOUT_PAGE_ABOUT_COMMITMENT_TO_INNOVATION}}
        </p>
    </div>
</section>

<section class="gradient-section-theme-color2">
    <div class="container">
        <h1>Why Choose Us?</h1>

        <div [innerHTML]="ABOUT_PAGE_ABOUT_WHY_CHOOSE_US"></div>

    </div>
</section>
-->

<!--
<section class="gradient-section-theme-color1">
    <div class="container">
        <h1>About Founder!</h1>
    </div>
</section>

<section class="gradient-section-theme-color1 text-center">
    <div class="container">
        <img src="images/about/awais-haleem-01.jpg" alt="Profile Image" class="profile-img mb-4">
        <h1>Mr. Haleem</h1>
        <h3>Founder and CEO of NordNative OÜ</h3>
        <p>
            {{ABOUT_PAGE_ABOUT_CEO}}
        </p>
    </div>
</section>
-->
<section class="gradient-section-theme-color2">
    <div class="container">
        <h1>Contact Us</h1>
        {{ABOUT_PAGE_CONTACT_US_PARA1}}

        <ul>
            <li>
                <strong>Phone</strong>: {{CONTACT_US_PHONE_MAIN}}
            </li>
            <li>
                <strong>Email</strong>: {{CONTACT_US_EMAIL_MAIN}}
            </li>
            <li>
                <strong>Website</strong>: {{CONTACT_US_WEB_MAIN}}
            </li>
            <li>
                <strong>Address</strong>: {{CONTACT_US_ADDRESS_MAIN}}
            </li>
        </ul>
        <!-- {{ABOUT_PAGE_CONTACT_US_PARA2}} -->

    </div>
</section>


<!--
<div class="col-xs-12" style="height:50px;"></div>

<section class="gradient-section text-center">
    <div class="container">
        <img src="images/about/awais-haleem-01.jpg" alt="Profile Image" class="profile-img mb-4">
        <h1>Salim Unya</h1>
        <h3>Founder and CEO of NordNative OÜ</h3>
        <p>
            {{ABOUT_PAGE_ABOUT_CEO}}

        </p>
    </div>
</section>
-->
<!-- Biography Section -->
<!-- <section class="bio-section">
    <div class="container">
        <div class="row">
            <div class="col-lg-8 offset-lg-2">
                <h2>Biography</h2>
                <p>
                    Mr. Haleem is serial enterprenurer in services and manufacturing business since 2011. He got a
                    vast experiene in working customer across the whole world.
                </p>
            </div>
        </div>
    </div>
</section>
-->
